export default __webpack_public_path__ + "static/media/Group 26086606.8eae77b8.svg";